/**
 * Android Back Button Handler Component
 * 
 * Componente wrapper che attiva la gestione del back button Android.
 * Deve essere montato una sola volta nell'app, preferibilmente vicino al Router.
 */

import { useAndroidBackButton } from '../../hooks/useAndroidBackButton';

export function AndroidBackButtonHandler() {
  useAndroidBackButton();
  return null; // Componente invisibile, solo logica
}
